<script>
    export let short = false;
    export let ajankohtaistaUrl = "2023-12-28_ahkerin";
    let title = "Vuoden 2023 ahkerin treenaaja!";
    let firstPara = "Taas on tullut aika löytää vuoden 2023 ahkerin treenaaja.";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                style="background-image: url('/svelte-site/img/ajankohtaista/Vuoden_Ahkerin_Mikko.jpeg')"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogDate">28.12.2023</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>
{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">28.12.2023</div>
            <p>{firstPara}</p>

            <p>Olemme jo kohta kymmenen vuoden ajan kannustaneet ja innostaneet ihmisiä treenaamaan säännöllisesti ja
                aktiivisesti. Vain säännöllisyydellä voi saada tuloksia. Meillä on ollut tapana vuosittain kiittää
                aktiivisinta treenaajaa. Vuoden 2023 ahkerin salikävijä on Mikko. Mikko sai kiitokseksi ahkeruudestaan
                muutaman leffalipun ja pari proteiinipatukkaa.</p>
            <p>Onnea Mikko!</p>


            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <img src='/svelte-site/img/ajankohtaista/Vuoden_Ahkerin_Mikko.jpeg' class="img" alt="">
                </div>
            </div>
        </article>
    </div>
{/if}

<style>


    .yhteistyossa {
        clear: both;
        font-size: 85%;
    }

    .yhteistyossa img {
        float: left;
        height: 90px;
        margin: 8px 32px 8px 0;
    }

    @media all and (max-width: 900px) {
        .yhteistyossa img {
            height: 80px;
        }
    }

</style>
